/** EFFET : dessin du maillage du visage (style cartoon années 30 : encre noire, traits épais). */
import { FaceLandmarker } from '@mediapipe/tasks-vision';
import type { Point3 } from '../detection/types';
import type { Projector } from './projection';

interface Connection {
  readonly start: number;
  readonly end: number;
}

const INK = '#1b1b1b';
const PAPER = '#f6efdc';
const IRIS_CENTERS = [468, 473];

const FEATURES: readonly (readonly Connection[])[] = [
  FaceLandmarker.FACE_LANDMARKS_LEFT_EYE,
  FaceLandmarker.FACE_LANDMARKS_RIGHT_EYE,
  FaceLandmarker.FACE_LANDMARKS_LEFT_EYEBROW,
  FaceLandmarker.FACE_LANDMARKS_RIGHT_EYEBROW,
  FaceLandmarker.FACE_LANDMARKS_LIPS,
];

function strokeConnections(
  ctx: CanvasRenderingContext2D,
  points: readonly Point3[],
  project: Projector,
  connections: readonly Connection[],
): void {
  ctx.beginPath();
  for (const { start, end } of connections) {
    const a = points[start];
    const b = points[end];
    if (!a || !b) continue;
    const pa = project(a);
    const pb = project(b);
    ctx.moveTo(pa.x, pa.y);
    ctx.lineTo(pb.x, pb.y);
  }
  ctx.stroke();
}

/** Efface le canvas (fond papier) et dessine le maillage ; rien si `points` est vide. */
export function drawMesh(
  ctx: CanvasRenderingContext2D,
  points: readonly Point3[],
  project: Projector,
  size: { width: number; height: number },
): void {
  ctx.fillStyle = PAPER;
  ctx.fillRect(0, 0, size.width, size.height);
  if (points.length === 0) return;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.strokeStyle = INK;

  ctx.globalAlpha = 0.18;
  ctx.lineWidth = 1;
  strokeConnections(ctx, points, project, FaceLandmarker.FACE_LANDMARKS_TESSELATION);

  ctx.globalAlpha = 1;
  ctx.lineWidth = 3;
  for (const feature of FEATURES) strokeConnections(ctx, points, project, feature);

  ctx.lineWidth = 6;
  strokeConnections(ctx, points, project, FaceLandmarker.FACE_LANDMARKS_FACE_OVAL);

  ctx.fillStyle = INK;
  for (const i of IRIS_CENTERS) {
    const p = points[i];
    if (!p) continue;
    const { x, y } = project(p);
    ctx.beginPath();
    ctx.arc(x, y, 5, 0, 2 * Math.PI);
    ctx.fill();
  }
}
